import { CESimpleAttributePermissionBase } from './ce-simple-attribute-permission-base'


export class CESimpleAttributePermission extends CESimpleAttributePermissionBase {

}